import { render, staticRenderFns } from "./RgGeolocator.vue?vue&type=template&id=778066bc&"
import script from "./RgGeolocator.vue?vue&type=script&lang=js&"
export * from "./RgGeolocator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports